import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
@font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 

  .generated-images-holder {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder {
    width: 100%;
    display: flex;
    position: relative;
  }

  .left-div, .right-div {
    width: 50%;
    height: 630px;
    position: relative;
  }

  .break {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
    &--black {
      background-color: black;
    }
  }
  .left-text, .right-text {
    position: absolute;
    width: 100%;
    padding: 0 10px;
    bottom: 35px;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #f3d400;
    font-weight: 700;
    font-family: CustomArial;
    letter-spacing: 1.6px;
    text-shadow: 1px 0 0 #f3d400;
    &--top {
      bottom: auto;
      top: 35px;
    }
    p {
      background-color: rgba(0,0,0,0.5);
      display: inline-block;
      margin: 0;
      padding: 14px 40px 16px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }

  .left-text__divider {
    padding: 0 13px 0 7px;
  }

  .right-text__divider {
    padding: 0 7px 0 13px;
  }

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .left-actual-photo {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .left-actual-photo--top {
    top: 0;
    bottom: auto;
  }
  .right-actual-photo {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .right-actual-photo--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
